export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  categorySlug: string;
  description: string;
  status: string;
  updatedAt: string;
  chapters: number;
  rating: number;
  views: number;
  tags: string[];
  content: string;
}

export const categories = [
  { name: '全部', slug: 'all', icon: 'ri-apps-line' },
  { name: '热血', slug: 'action', icon: 'ri-fire-line' },
  { name: '恋爱', slug: 'romance', icon: 'ri-heart-line' },
  { name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line' },
  { name: '悬疑', slug: 'thriller', icon: 'ri-search-eye-line' },
  { name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line' },
  { name: '日常', slug: 'slice-of-life', icon: 'ri-calendar-line' },
  { name: '恐怖', slug: 'horror', icon: 'ri-ghost-line' },
];

export const comics: Comic[] = [
  {
    id: 'comic-001',
    title: '剑与魔法',
    author: '金泰亨',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20fantasy%20sword%20and%20magic%20warrior%20epic%20adventure%20dramatic%20lighting%20detailed%20illustration%20style%20clean%20white%20background&width=600&height=800&seq=comic-cover-001&orientation=portrait',
    category: '热血',
    categorySlug: 'action',
    description: '在一个被黑暗势力笼罩的大陆上，年轻的剑士艾伦踏上了寻找传说之剑的冒险旅程。途中他结识了各路伙伴，用勇气和信念战胜一个又一个强敌。热血沸腾的战斗场面与感人至深的友情故事交织，带你进入一个宏大的奇幻世界。',
    status: '连载中',
    updatedAt: '2026-08-04',
    chapters: 187,
    rating: 4.8,
    views: 12500000,
    tags: ['冒险', '战斗', '友情', '成长'],
    content: '在一个被黑暗势力笼罩的大陆上，年轻的剑士艾伦踏上了寻找传说之剑的冒险旅程。途中他结识了各路伙伴...',
  },
  {
    id: 'comic-002',
    title: '恋爱的温度',
    author: '李智慧',
    cover: 'https://readdy.ai/api/search-image?query=romantic%20Korean%20webtoon%20cover%20art%20young%20couple%20cherry%20blossom%20spring%20warm%20sunlight%20soft%20pastel%20colors%20gentle%20romance%20illustration%20style%20clean%20background&width=600&height=800&seq=comic-cover-002&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    description: '两个性格截然不同的人在大学校园里相遇。他冷静理性，她热情活泼。一场意外的实验室事故让他们开始了一段奇妙的同居生活。在朝夕相处中，两颗心慢慢靠近，展开了一段甜蜜又充满笑料的恋爱故事。',
    status: '连载中',
    updatedAt: '2026-08-04',
    chapters: 96,
    rating: 4.6,
    views: 8900000,
    tags: ['校园', '同居', '甜蜜', '日常'],
    content: '两个性格截然不同的人在大学校园里相遇。他冷静理性，她热情活泼...',
  },
  {
    id: 'comic-003',
    title: '异界猎人',
    author: '朴志浩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20dark%20fantasy%20monster%20hunter%20gates%20dungeon%20modern%20weapons%20mysterious%20atmosphere%20detailed%20action%20illustration%20style&width=600&height=800&seq=comic-cover-003&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    description: '世界各地突然出现了连接异次元的「门」，怪物从中涌出。只有觉醒特殊能力的「猎人」才能对抗这些怪物。一个曾经被视为最弱E级猎人的青年，在一次濒死体验中觉醒了隐藏的力量，成为人类最后的希望。',
    status: '连载中',
    updatedAt: '2026-08-03',
    chapters: 234,
    rating: 4.9,
    views: 21000000,
    tags: ['系统', '升级', '怪物', '觉醒'],
    content: '世界各地突然出现了连接异次元的「门」，怪物从中涌出...',
  },
  {
    id: 'comic-004',
    title: '深渊之眼',
    author: '崔敏秀',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20psychological%20thriller%20mystery%20dark%20tone%20ominous%20eye%20symbol%20suspense%20noir%20atmosphere%20dramatic%20illustration%20style&width=600&height=800&seq=comic-cover-004&orientation=portrait',
    category: '悬疑',
    categorySlug: 'thriller',
    description: '刑警韩智勋接手了一桩离奇的连环失踪案。所有失踪者在消失前都曾收到一个神秘的眼睛图案。随着调查的深入，他发现这个案件与二十年前的一起灭门惨案有着千丝万缕的联系。真相远比想象中更加令人毛骨悚然。',
    status: '已完结',
    updatedAt: '2026-07-28',
    chapters: 156,
    rating: 4.7,
    views: 7600000,
    tags: ['推理', '悬疑', '犯罪', '反转'],
    content: '刑警韩智勋接手了一桩离奇的连环失踪案...',
  },
  {
    id: 'comic-005',
    title: '废柴逆袭记',
    author: '张成宇',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20comedy%20school%20life%20underdog%20student%20funny%20expression%20bright%20colorful%20exaggerated%20cartoon%20style%20clean%20white%20background&width=600&height=800&seq=comic-cover-005&orientation=portrait',
    category: '搞笑',
    categorySlug: 'comedy',
    description: '全校公认的废柴少年意外获得了一个神奇的系统——只要完成各种荒诞的任务就能获得超能力。从此他的校园生活变得鸡飞狗跳，笑料百出。但在欢笑的背后，一段关于成长的励志故事正在悄然展开。',
    status: '连载中',
    updatedAt: '2026-08-04',
    chapters: 112,
    rating: 4.4,
    views: 5600000,
    tags: ['校园', '系统', '搞笑', '励志'],
    content: '全校公认的废柴少年意外获得了一个神奇的系统...',
  },
  {
    id: 'comic-006',
    title: '夏日旋律',
    author: '郑秀雅',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20slice%20of%20life%20summer%20music%20guitar%20warm%20sunlight%20youth%20friendship%20nostalgic%20vibe%20soft%20color%20tones%20gentle%20illustration%20style&width=600&height=800&seq=comic-cover-006&orientation=portrait',
    category: '日常',
    categorySlug: 'slice-of-life',
    description: '一个热爱音乐的普通高中生，在暑假的最后一天遇到了一个神秘的音乐少女。两人因为对音乐的共同热爱走到了一起，组建了校园乐队。青春、音乐、友谊，这个夏天注定不平凡。',
    status: '已完结',
    updatedAt: '2026-07-15',
    chapters: 88,
    rating: 4.5,
    views: 4200000,
    tags: ['音乐', '校园', '青春', '治愈'],
    content: '一个热爱音乐的普通高中生，在暑假的最后一天遇到了一个神秘的音乐少女...',
  },
  {
    id: 'comic-007',
    title: '暗夜传说',
    author: '尹在赫',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20horror%20ghost%20story%20dark%20night%20supernatural%20eerie%20atmosphere%20shadow%20figure%20frightening%20illustration%20style%20clean%20dark%20background&width=600&height=800&seq=comic-cover-007&orientation=portrait',
    category: '恐怖',
    categorySlug: 'horror',
    description: '深夜的图书馆里，管理员总能听到奇怪的声音。一本被封印的古籍被意外打开，释放出了沉睡千年的恶灵。每一个翻开这本书的人，都将遭遇不可名状的恐怖。你能撑到最后一页吗？',
    status: '连载中',
    updatedAt: '2026-08-02',
    chapters: 67,
    rating: 4.3,
    views: 3800000,
    tags: ['灵异', '恐怖', '古籍', '诅咒'],
    content: '深夜的图书馆里，管理员总能听到奇怪的声音...',
  },
  {
    id: 'comic-008',
    title: '武林至尊',
    author: '金泰亨',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20martial%20arts%20murim%20warrior%20ancient%20China%20style%20epic%20battle%20dramatic%20pose%20action%20dynamic%20illustration%20style%20clean%20background&width=600&height=800&seq=comic-cover-008&orientation=portrait',
    category: '热血',
    categorySlug: 'action',
    description: '一个被武林正道追杀的少年，在绝境中得到了失传百年的绝世武功秘籍。从此踏上了复仇与成长的道路，一步步从无名小卒成长为威震武林的至尊强者。江湖恩怨，儿女情长，尽在其中。',
    status: '已完结',
    updatedAt: '2026-06-20',
    chapters: 312,
    rating: 4.9,
    views: 18500000,
    tags: ['武侠', '复仇', '成长', '江湖'],
    content: '一个被武林正道追杀的少年，在绝境中得到了失传百年的绝世武功秘籍...',
  },
  {
    id: 'comic-009',
    title: '星之恋语',
    author: '李智慧',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20cover%20art%20starry%20night%20sky%20couple%20looking%20at%20stars%20romantic%20atmosphere%20soft%20glowing%20light%20beautiful%20illustration%20style%20clean%20background&width=600&height=800&seq=comic-cover-009&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    description: '天文系的天才少女和摇滚乐队的主唱，两个看似毫无交集的人因为一次流星雨的观测而相遇。他用音乐拨动她的心弦，她教他认识每一颗星星的名字。一场跨越不同世界的浪漫爱情，如星辰般璀璨。',
    status: '连载中',
    updatedAt: '2026-08-05',
    chapters: 54,
    rating: 4.7,
    views: 5100000,
    tags: ['音乐', '天文', '浪漫', '才女'],
    content: '天文系的天才少女和摇滚乐队的主唱，两个看似毫无交集的人因为一次流星雨的观测而相遇...',
  },
  {
    id: 'comic-010',
    title: '魔王重生',
    author: '朴志浩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20dark%20lord%20reincarnation%20fantasy%20world%20magic%20powerful%20demon%20king%20epic%20scale%20majestic%20illustration%20style%20clean%20dark%20background&width=600&height=800&seq=comic-cover-010&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    description: '曾经统治魔界的魔王被勇者击败后，灵魂穿越到了现代社会的一个普通高中生身上。在这个陌生的世界里，他一边适应着平凡的生活，一边暗中积蓄力量，准备重返魔界夺回属于自己的一切。',
    status: '连载中',
    updatedAt: '2026-08-04',
    chapters: 145,
    rating: 4.8,
    views: 15200000,
    tags: ['穿越', '魔王', '校园', '逆袭'],
    content: '曾经统治魔界的魔王被勇者击败后，灵魂穿越到了现代社会的一个普通高中生身上...',
  },
  {
    id: 'comic-011',
    title: '黎明之刃',
    author: '崔敏秀',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20assassin%20revenge%20dark%20action%20blade%20noir%20style%20dramatic%20lighting%20mysterious%20character%20intense%20illustration%20style%20clean%20background&width=600&height=800&seq=comic-cover-011&orientation=portrait',
    category: '悬疑',
    categorySlug: 'thriller',
    description: '一个顶级杀手在一次任务中发现自己被组织出卖。为了找出幕后黑手，他不得不一边躲避追杀，一边寻找真相。在这场猫鼠游戏中，每一个选择都可能致命。',
    status: '连载中',
    updatedAt: '2026-08-03',
    chapters: 89,
    rating: 4.6,
    views: 6400000,
    tags: ['杀手', '复仇', '动作', '阴谋'],
    content: '一个顶级杀手在一次任务中发现自己被组织出卖...',
  },
  {
    id: 'comic-012',
    title: '社长大人请留步',
    author: '张成宇',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20office%20romantic%20comedy%20CEO%20and%20employee%20funny%20workplace%20bright%20cheerful%20cartoon%20style%20clean%20white%20background&width=600&height=800&seq=comic-cover-012&orientation=portrait',
    category: '搞笑',
    categorySlug: 'comedy',
    description: '一个冒冒失失的职场新人阴差阳错成了冷酷社长的私人助理。每天都上演着让人捧腹的办公室闹剧。然而在笑声中，一段意料之外的办公室恋情正在悄悄萌芽。',
    status: '连载中',
    updatedAt: '2026-08-04',
    chapters: 78,
    rating: 4.5,
    views: 4900000,
    tags: ['职场', '恋爱', '搞笑', '办公室'],
    content: '一个冒冒失失的职场新人阴差阳错成了冷酷社长的私人助理...',
  },
  {
    id: 'comic-013',
    title: '治愈咖啡馆',
    author: '郑秀雅',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20cozy%20cafe%20healing%20slice%20of%20life%20warm%20atmosphere%20coffee%20shop%20comforting%20vibe%20soft%20pastel%20colors%20gentle%20illustration%20style%20clean%20background&width=600&height=800&seq=comic-cover-013&orientation=portrait',
    category: '日常',
    categorySlug: 'slice-of-life',
    description: '在一座安静的小城里，有一家名为「治愈」的咖啡馆。每一个来这里的人都有着属于自己的故事。店主用一杯杯温暖的咖啡和一个个暖心的小故事，治愈着每一个疲惫的灵魂。',
    status: '已完结',
    updatedAt: '2026-07-10',
    chapters: 72,
    rating: 4.8,
    views: 6100000,
    tags: ['治愈', '咖啡', '温情', '单元剧'],
    content: '在一座安静的小城里，有一家名为「治愈」的咖啡馆...',
  },
  {
    id: 'comic-014',
    title: '灵魂摆渡人',
    author: '尹在赫',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20art%20supernatural%20grim%20reaper%20soul%20afterlife%20mysterious%20dark%20and%20beautiful%20contrast%20ethereal%20illustration%20style%20clean%20dark%20background&width=600&height=800&seq=comic-cover-014&orientation=portrait',
    category: '恐怖',
    categorySlug: 'horror',
    description: '在生与死的边界，有一群被称为「灵魂摆渡人」的存在。他们负责将逝者的灵魂引渡到来世。但当一位摆渡人遇到一个拒绝离去的灵魂时，一段跨越生死的奇妙旅程就此展开。',
    status: '连载中',
    updatedAt: '2026-08-01',
    chapters: 43,
    rating: 4.4,
    views: 3200000,
    tags: ['灵异', '生死', '感动', '奇幻'],
    content: '在生与死的边界，有一群被称为「灵魂摆渡人」的存在...',
  },
  {
    id: 'comic-015',
    title: '拳皇之路',
    author: '金泰亨',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20boxing%20fighter%20sports%20action%20training%20ring%20intense%20determination%20dynamic%20fighting%20pose%20dramatic%20illustration%20style%20clean%20background&width=600&height=800&seq=comic-cover-015&orientation=portrait',
    category: '热血',
    categorySlug: 'action',
    description: '一个来自贫民窟的少年，凭借着过人的天赋和不懈的努力，一步步从业余拳击手成长为世界拳王。擂台上每一拳都承载着他的梦想和汗水，这是一条用拳头铺就的荣耀之路。',
    status: '连载中',
    updatedAt: '2026-08-05',
    chapters: 165,
    rating: 4.7,
    views: 9700000,
    tags: ['拳击', '体育', '励志', '热血'],
    content: '一个来自贫民窟的少年，凭借着过人的天赋和不懈的努力...',
  },
  {
    id: 'comic-016',
    title: '花与蝶',
    author: '李智慧',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20cover%20art%20historical%20period%20romance%20traditional%20hanbok%20flower%20garden%20elegant%20beautiful%20poetic%20atmosphere%20soft%20illustration%20style%20clean%20background&width=600&height=800&seq=comic-cover-016&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    description: '朝鲜时代，一位贵族小姐和一位平民画师之间跨越阶级的爱情故事。她如同花园中最美的花朵，而他则是为她停留的蝴蝶。在那个礼教森严的年代，他们的爱情将何去何从？',
    status: '已完结',
    updatedAt: '2026-06-30',
    chapters: 120,
    rating: 4.9,
    views: 8200000,
    tags: ['古风', '爱情', '阶级', '唯美'],
    content: '朝鲜时代，一位贵族小姐和一位平民画师之间跨越阶级的爱情故事...',
  },
  {
    id: 'comic-017',
    title: '次元图书馆',
    author: '崔敏秀',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20mysterious%20library%20parallel%20dimension%20books%20magical%20portal%20fantasy%20mystery%20intellectual%20atmosphere%20detailed%20illustration%20style%20clean%20background&width=600&height=800&seq=comic-cover-017&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    description: '在一座古老图书馆的地下室中，隐藏着一个通往无数平行世界的入口。图书管理员林晓在整理古籍时意外发现了这个秘密。从此，他踏上了穿越各个次元、收集失落知识的冒险之旅。',
    status: '连载中',
    updatedAt: '2026-08-05',
    chapters: 56,
    rating: 4.6,
    views: 4100000,
    tags: ['穿越', '图书馆', '冒险', '知识'],
    content: '在一座古老图书馆的地下室中，隐藏着一个通往无数平行世界的入口...',
  },
];

export const faqItems = [
  {
    question: '免费韩漫大全需要注册才能阅读吗？',
    answer: '完全不需要注册！免费韩漫大全的所有漫画均可以直接在线阅读，无需任何注册或登录步骤。我们希望为用户提供最便捷的阅读体验，让每一位漫画爱好者都能随时随地享受韩漫的乐趣。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '我们每日更新最新章节，确保读者能够在第一时间阅读到最新的韩漫内容。热门连载漫画通常每日更新一话，已完结作品则可以一次性畅读全集。关注我们的更新日历，不错过任何精彩内容。',
  },
  {
    question: '可以在手机上阅读吗？',
    answer: '当然可以！免费韩漫大全采用响应式网页设计，完美适配手机、平板和电脑等各种设备。无论你是在通勤路上、午休时间还是睡前放松，都能获得流畅舒适的阅读体验。',
  },
  {
    question: '支持哪些类型的韩国漫画？',
    answer: '我们涵盖热血、恋爱、奇幻、悬疑、搞笑、日常、恐怖等全品类韩漫，满足不同读者的口味偏好。无论你喜欢紧张刺激的战斗场面，还是甜蜜治愈的爱情故事，都能在这里找到心仪的作品。',
  },
  {
    question: '如何查找我想看的漫画？',
    answer: '你可以通过首页的分类导航按类型浏览漫画，也可以使用（即将上线的）搜索功能直接搜索作品名称或作者。我们还会在首页推荐热门作品和最新更新，帮你发现更多优质韩漫。',
  },
];